import axios from 'axios'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import { DEFAULT_PAGE_SAZE } from '../../../common/PrimeTable/CustomPrimeTable'
import { notificationSuccess } from '../../../utils/customToastify'
import { getContact, getContactDivision, getContactsDivisions } from '../../Contacts/redux/ContactActions'
import { GET_ALL_DATA, SET_LOADING } from './types'

export const setLoading = () => ({
  type: SET_LOADING,
})

export const markContractLost = (data) => async (dispatch) => {
  const response = await axios.post('/contract-lost', data)

  if (response.status === 200) {
    dispatch(closeModal('mark_contract_lost'))
    notificationSuccess('Successfully marked contract lost')
    await dispatch(getContactsDivisions(data.contactId))
    await dispatch(getContactDivision(data.divisionId, data.contactId))
    await dispatch(
      getContactContractLostHistory(data.contactId, {
        pagination: { limit: DEFAULT_PAGE_SAZE, first: 0 },
        sort: {},
        filter: { divisionId: data.divisionId },
        tableFilter: {},
      })
    )
    await dispatch(getContact(data.contactId, data.divisionId))
  }
}

export const getAllContractLost = (options) => async (dispatch) => {
  dispatch(setLoading())

  const response = await axios.get('/contract-lost', { params: options })
  dispatch({
    type: GET_ALL_DATA,
    payload: response.data,
  })
}

export const getContactContractLostHistory = (contactId, options) => async (dispatch) => {
  dispatch(setLoading())

  const response = await axios.get(`/contract-lost/${contactId}`, { params: options })
  dispatch({
    type: GET_ALL_DATA,
    payload: response.data,
  })
}
